export default "__VITE_ASSET__Dwh$zsGo__"